import { BaseEntity } from 'yt-ng-framework';


export class VrstaDatumaPoreskeObaveze extends BaseEntity{
    constructor(){
        super();
    }
    
    Sifra: string=null;
    Opis: string=null;
    is_active: boolean;
    Deserialize(input: any){
        this.ID = input.ID;
        this.Sifra = input.Sifra;
        this.Opis= input.Opis;
        return this;
    }

    Serialize(input: VrstaDatumaPoreskeObaveze){
        return input;
    }
}
